const Data = {
  enterPageSection: [
    {
      src: require("./Assets/enterpage/danandmom.webp"),
    },
    {
      src: require("./Assets/enterpage/montreal.webp"),
    },
    {
      src: require("./Assets/enterpage/orna.webp"),
      desktopSrc: require("./Assets/enterpage/desktopAndTablet/ornaDesktop.webp"),
    },
    {
      src: require("./Assets/enterpage/cake.webp"),
    },
    {
      src: require("./Assets/enterpage/jcdan.webp"),
    },
    {
      src: require("./Assets/enterpage/babydan.webp"),
      desktopSrc: require("./Assets/enterpage/desktopAndTablet/babyDanDesktop.webp"),
    },
    {
      src: require("./Assets/enterpage/glasses.webp"),
      desktopSrc: require("./Assets/enterpage/desktopAndTablet/glassesDesktop.webp"),
    },

    {
      src: require("./Assets/enterpage/sheis.webp"),
      desktopSrc: require("./Assets/enterpage/desktopAndTablet/sheistyDanDesktop.webp"),
    },
    {
      src: require("./Assets/enterpage/tim.webp"),
      desktopSrc: require("./Assets/enterpage/desktopAndTablet/danTimDesktop.webp"),
    },
    {
      src: require("./Assets/enterpage/danMomLiz.webp"),
      desktopSrc: require("./Assets/enterpage/desktopAndTablet/momChristDesktop.webp"),
    },
    {
      src: require("./Assets/enterpage/danMomShop.webp"),
      desktopSrc: require("./Assets/enterpage/desktopAndTablet/danMomShopDesktop.webp"),
    },
    {
      src: require("./Assets/enterpage/korean.webp"),
      desktopSrc: require("./Assets/enterpage/desktopAndTablet/danKoreanDesktop.webp"),
    },
    {
      src: require("./Assets/enterpage/danMomSubway.webp"),
      desktopSrc: require("./Assets/enterpage/desktopAndTablet/danTrainDesktop.webp"),
    },
    {
      src: require("./Assets/enterpage/danAsher.webp"),
      desktopSrc: require("./Assets/enterpage/desktopAndTablet/danAsherDesktop.webp"),
    },
  ],

  galleryCardInfo: [
    {
      img: require("./Assets/gallery/frisbee.webp"),
      plpImages: [
        { src: require("./Assets/plp/frisbee/frisbee1.webp") },
        { src: require("./Assets/plp/frisbee/frisbee2.webp") },

        { src: require("./Assets/plp/frisbee/frisbee4.webp") },
        { src: require("./Assets/plp/frisbee/frisbee5.webp") },
        { src: require("./Assets/plp/frisbee/frisbee6.webp") },
        { src: require("./Assets/plp/frisbee/frisbee7.webp") },
        { src: require("./Assets/plp/frisbee/frisbee8.webp") },
        { src: require("./Assets/plp/frisbee/frisbee9.webp") },

        { src: require("./Assets/plp/frisbee/frisbee11.webp") },
        // Add more images as needed
      ],
      altText: "frisbee",
      title: "ultimate frisbee",
      info: "I play ultimate frisbee for the Rutgers club team as a handler and it's been super fun so far. I've played since high school and on club teams. I guess all those backhands at the family cookout paid off.",
    },
    {
      img: require("./Assets/gallery/eliv.webp"),
      plpImages: [
        { src: require("./Assets/plp/volunteer/tacov.webp") },
        { src: require("./Assets/plp/volunteer/nesv.webp") },

        // Add more images as needed
      ],

      altText: "volunteering",
      title: "volunteering",
      info: "In my free time, I love to volunteer!! Right now I'm volunteering at Elijah's Promise in New Brunswick, preparing food and serving meals to the community. I really like anything to do with food, especially cooking and serving others. It's been such an amazing blessing and time at Elijah's kitchen, not only knowing that I'm doing it for a great purpose, but also meeting other volunteers has been so humbling and rewarding. The past summer, while living in NYC, I volunteered at God's Love packing lentil soup and also preparing and serving food bags at St. Paul's food pantry. Let me know if you'd ever want to volunteer together!! ",
    },
    {
      img: require("./Assets/gallery/cooking.webp"),
      plpImages: [
        { src: require("./Assets/plp/cooking/noodle.webp") },
        { src: require("./Assets/plp/cooking/soup.webp") },
        { src: require("./Assets/plp/cooking/sushi.webp") },
        { src: require("./Assets/plp/cooking/food4.webp") },
        { src: require("./Assets/plp/cooking/rolls.webp") },
        { src: require("./Assets/plp/cooking/spread.webp") },
        // Add more images as needed
      ],
      altText: "dan han cooking",
      title: "in the lab",
      info: "In my free time, I enjoy cooking different recipes and learning new techniques. I also love feeding my friends and family. Some of my best memories come from breaking bread with others and I want to be able to provide that for those around me.",
    },
    {
      img: require("./Assets/gallery/nestle.webp"),
      plpImages: [
        { src: require("./Assets/plp/nespresso/nes1.webp") },
        { src: require("./Assets/plp/nespresso/nes2.webp") },
        { src: require("./Assets/plp/nespresso/nes3.webp") },
        { src: require("./Assets/plp/nespresso/nes4.webp") },
        { src: require("./Assets/plp/nespresso/nes5.webp") },
        // Add more images as needed
      ],
      altText: "nespresso internship",
      title: "nespresso",
      info: "The past Summer I interned at Nespresso as a front end developer. During my time here, I was able to polish my React skills which helped me make this website. I created two main components for their website redesign that I'm super proud of. I didn't think I would be able to make such an impact as an intern, but we defy the limits here. And yes, I drank a lotttt of free coffee!!",
    },
    {
      img: require("./Assets/gallery/RAdorm.webp"),
      plpImages: [
        { src: require("./Assets/plp/RA/RA1.webp") },
        { src: require("./Assets/plp/RA/RA2.webp") },
        { src: require("./Assets/plp/RA/RA3.webp") },
        { src: require("./Assets/plp/RA/RA4.webp") },
        { src: require("./Assets/plp/RA/RA5.webp") },
        { src: require("./Assets/plp/RA/RA6.webp") },
        { src: require("./Assets/plp/RA/RA7.webp") },

        // Add more images as needed
      ],
      altText: "resident assistant",
      title: "RA Han",
      info: "Last year I RA'd for freshman housing, but this year I got a nice upgrade to an apartment. Call me super RA.",
    },
    {
      img: require("./Assets/gallery/danfam.webp"),
      plpImages: [
        { src: require("./Assets/plp/fam/lucas.webp") },
        { src: require("./Assets/plp/fam/lucas2.webp") },
        { src: require("./Assets/plp/fam/danFamEat.webp") },
        { src: require("./Assets/plp/fam/DanGrampFam.webp") },
        { src: require("./Assets/plp/fam/fam3.webp") },
        { src: require("./Assets/plp/fam/fam4.webp") },
        { src: require("./Assets/plp/fam/fam5.webp") },
        { src: require("./Assets/plp/fam/fam6.webp") },
        { src: require("./Assets/plp/fam/fam7.webp") },
        { src: require("./Assets/plp/fam/fam8.webp") },
        { src: require("./Assets/plp/fam/fam9.webp") },
        { src: require("./Assets/plp/fam/jonny.webp") },
        // Add more images as needed
      ],
      altText: "family values",
      title: "big family guy",
      info: "I love spending quality time with my family, whether it's going on trips, celebrating holidays, or just hanging out at home. Yes, I'm the youngest, the favorite, and have two older sisters!",
    },
    {
      img: require("./Assets/gallery/twon.webp"),
      plpImages: [
        { src: require("./Assets/plp/friends/alan.webp") },
        { src: require("./Assets/plp/friends/elaine.webp") },
        { src: require("./Assets/plp/friends/point.webp") },
        { src: require("./Assets/plp/friends/pointban.webp") },
        { src: require("./Assets/plp/friends/vish.webp") },
        { src: require("./Assets/plp/friends/danAlanPack.webp") },
        { src: require("./Assets/plp/friends/friend1.jpeg") },
        { src: require("./Assets/plp/friends/friend2.jpeg") },
        { src: require("./Assets/plp/friends/dhan.webp") },
        { src: require("./Assets/plp/friends/montreal1.webp") },
        { src: require("./Assets/plp/friends/montreal2.webp") },
        { src: require("./Assets/plp/friends/montreal3.webp") },
        { src: require("./Assets/plp/friends/montreal4.webp") },
        // Add more images as needed
      ],
      altText: "hanging out with friends ",
      title: "kickback",
      info: "Never forget your roots.",
    },

    {
      img: require("./Assets/gallery/tbell.webp"),
      plpImages: [
        { src: require("./Assets/plp/tacobell/tbell1.webp") },
        { src: require("./Assets/plp/tacobell/tbell2.webp") },
        { src: require("./Assets/plp/tacobell/tbell3.webp") },
        { src: require("./Assets/plp/tacobell/tbell4.webp") },
        { src: require("./Assets/plp/tacobell/tbell5.webp") },
        { src: require("./Assets/plp/tacobell/tbell6.webp") },
        // Add more images as needed
      ],
      altText: "working at tbell",
      title: "humble beginnings",
      info: "My first job was working at Taco Bell as a steamer on the line. It holds a special place as the Taco Bell Foundation has funded my college education as well and working there taught me valuable skills. Don't forget to live mas.",
    },
    {
      img: require("./Assets/gallery/dough.webp"),
      plpImages: [
        { src: require("./Assets/plp/sourdough/sour1.webp") },
        { src: require("./Assets/plp/sourdough/sour2.webp") },
        { src: require("./Assets/plp/sourdough/sour3.webp") },
        { src: require("./Assets/plp/sourdough/sour4.webp") },
        { src: require("./Assets/plp/sourdough/sour5.webp") },
        { src: require("./Assets/plp/sourdough/sour6.webp") },
        { src: require("./Assets/plp/sourdough/sour7.webp") },
        { src: require("./Assets/plp/sourdough/sour8.webp") },
        { src: require("./Assets/plp/sourdough/sour9.webp") },
        { src: require("./Assets/plp/sourdough/sour10.webp") },
        { src: require("./Assets/plp/sourdough/sour11.webp") },
        { src: require("./Assets/plp/sourdough/sour12.webp") },
        { src: require("./Assets/plp/sourdough/sour13.webp") },
        { src: require("./Assets/plp/sourdough/sour14.webp") },
        { src: require("./Assets/plp/sourdough/sour15.webp") },
        { src: require("./Assets/plp/sourdough/sour16.webp") },

        // Add more images as needed
      ],
      altText: "sourdough  baking",
      title: "sourdough",
      info: "I got into sourdough baking this past summer! I love the process of making a loaf from start to finish. And no, I haven't named my starter yet.. lol. Sourdough bread making is super appealing to me and such a rewarding process. I'm trying to make homemade croissants next!!",
    },
    {
      img: require("./Assets/gallery/coffee.webp"),
      plpImages: [
        { src: require("./Assets/plp/coffee/matcha.webp") },
        { src: require("./Assets/plp/coffee/coffee.webp") },
        { src: require("./Assets/plp/coffee/esp.webp") },
        { src: require("./Assets/plp/coffee/stump.webp") },

        // Add more images as needed
      ],
      altText: "fresh coffee",
      title: "morning cup",
      info: "I love coffee and enjoy trying new roasts and brewing methods. I'm into selecting my coffee beans, grinding them fresh, and preparing my coffee in various ways. Right now I'm using a timemore c2 grinder and aeropress. I have a pourover set but I don't use it too often. I've also been super into making iced dirty matcha lattes. Down the line, I definitely want to get an espresso machine, moka pot, and french press. I know I have an obsession",
    },
    {
      img: require("./Assets/plp/golf/dantee.webp"),
      plpImages: [
        { src: require("./Assets/plp/golf/danGolf.webp") },
        { src: require("./Assets/plp/golf/danGolfFam.webp") },
        { src: require("./Assets/plp/golf/golf1.webp") },

        // Add more images as needed
      ],
      altText: "dan like golf",
      title: "golf",
      info: "In my free time, I also like to play golf. I got into it because my dad loves playing, and I just wanted to spend more quality time with him. I still suck and shank most of my tee offs.",
    },
    {
      img: require("./Assets/plp/korea/korea13.webp"),
      plpImages: [
        { src: require("./Assets/plp/korea/korea1.webp") },
        { src: require("./Assets/plp/korea/korea2.webp") },
        { src: require("./Assets/plp/korea/korea3.webp") },
        { src: require("./Assets/plp/korea/korea4.webp") },
        { src: require("./Assets/plp/korea/korea5.webp") },
        { src: require("./Assets/plp/korea/korea6.webp") },
        { src: require("./Assets/plp/korea/korea7.webp") },
        { src: require("./Assets/plp/korea/korea8.webp") },
        { src: require("./Assets/plp/korea/korea9.webp") },
        { src: require("./Assets/plp/korea/korea10.webp") },
        { src: require("./Assets/plp/korea/korea11.webp") },
        { src: require("./Assets/plp/korea/korea12.webp") },
        { src: require("./Assets/plp/korea/korea.webp") },
        { src: require("./Assets/plp/korea/korea14.webp") },
        { src: require("./Assets/plp/korea/korea15.webp") },
        { src: require("./Assets/plp/korea/korea16.webp") },

        // Add more images as needed
      ],
      altText: "dan loves korea",
      title: "korea",
      info: "I've traveled to Korea two times!! First being a study abroad program at Ewha womans university in Seoul, where I participated in their summer co-ed program. I worked on a personal research project, interned at a think tank, and took a Korean elective course on neoliberalism. The following summer, I went to Korea again, this time with my sister to travel. We went to Daegu, Busan, Gyeongju, Jeonju, and Jeju. We also spent quality time with our relatives in Seoul. I think it goes without saying that their food is amazing and super affordable. Really missing that!!  ",
    },
  ],

  aboutSection: {
    card1: {
      title: "About Me",
      content:
        "Hi! I'm Dan, a software engineer based in New Jersey. I have a passion for creating and building things. I specialize in front end development, hoping to provide the best user experience possible. I currently study computer science and Korean at Rutgers University in NJ.",
    },
  },
  programmingSection: [
    { img: require("./Assets/programmingmarquee/java.webp") },
    { img: require("./Assets/programmingmarquee/pythonnew.webp") },
    { img: require("./Assets/programmingmarquee/sql.webp") },
    { img: require("./Assets/programmingmarquee/typescript.webp") },
    { img: require("./Assets/programmingmarquee/html.webp") },
    { img: require("./Assets/programmingmarquee/css.webp") },
    { img: require("./Assets/programmingmarquee/js.webp") },
    { img: require("./Assets/programmingmarquee/swift.webp") },
    { img: require("./Assets/programmingmarquee/React.webp") },
    { img: require("./Assets/programmingmarquee/sfmc.webp") },
  ],
  aboutMeSection: {
    contact: {
      location: "NJ, NY",
      email: "daniel.hangb@gmail.com",
    },
    experience: [
      {
        title: "Nestle Nespresso",
        position: "Front End Developer Intern",
        date: "June 2024 - August 2024",
        description:
          "Worked on the redesign of the Nespresso website, creating two main components for the new site. Developed in React using TypeScript, CSS, and HTML. Used Storybook for viewing individual components and react testing library for writing custom test cases. Implemented a component that autoplays through multiple videos, and displays different text content for each video. Also implemented a component that showcases 3 different Nespresso machines, represented by a button to route to a different product.",
      },
      {
        title: "Colgate-Palmolive",
        position: "Application & Software Developer Intern",
        date: "January 2023 - November 2023",
        description:
          "Worked on an embedded c project connecting a Bosch BME688 gas sensor with a Silicon Labs EFR32BG22 micro controller. Also worked on writing Python scripts for Salesforce Marketing cloud, and creating API endpoints for an internal Django web application. ",
      },
    ],
    education: [
      {
        title: "Rutgers University",
        date: "September 2021 - May 2025",
        majors: {
          major1: {
            title: "Computer Science",
            courses: [
              "Intro to CS",
              "Discrete Structures",
              "Linear Algebra",
              "Data Structures and Algorithms",
              "Software Methodology",
              "Computer Architecture",
              "Design and Analysis of Algorithms",
              "Data Science",
              "Database Management",
              "Internet Technology",
              "Numerical Analysis & Computing",
              "Minds, Machines, and Persons",
            ],
          },
          major2: {
            title: "Korean",
            courses: [
              "Elementary Korean 101",
              "Elementary Korean 102",
              "Intermediate Korean 201",
              "Intermediate Korean 202",
              "Advanced Korean 301",
              "Advanced Korean 302",
              "Advanced Readings in Korean 401",
              "Intro to Korean Culture 210",
              "Intro to Korean Literature in Translation 220",
              "Korean Translation 320",
              "Korean Politics @UMich 390",
              "Everyday Life in the Neoliberal City 392",
            ],
          },
        },
      },
    ],
  },
};

export default Data;
